import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private currentVersion: number | null = null;

  constructor(private http: HttpClient) {}

  /**
   * Starts periodic checking of version.json
   * @param frequencyMs how often to check (default 30s)
   */
  public initVersionCheck(frequencyMs: number = 30000): void {
    interval(frequencyMs).pipe(
      switchMap(() => this.http.get<{ buildDate: number }>(
        `/assets/version.json?nocache=${Date.now()}`
      ).pipe(
        catchError(() => of(null)) // prevent breaking if file missing
      ))
    ).subscribe(versionInfo => {
      if (!versionInfo) {
        return;
      }
      if (!this.currentVersion) {
        this.currentVersion = versionInfo.buildDate;
      } else if (this.currentVersion !== versionInfo.buildDate) {
        console.log('♻️ New build detected. Reloading app...');
        window.location.reload();
      }
    });
  }
}